import { useContext } from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTheme } from '@forma/forma-ui-theme';
import MediaGrid from '@/components/blocks/MediaGrid/MediaGrid';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import PageTitle from '@/components/PageTitle';

import mockApi from '@/api/mockApi';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const headersParse = await getHeadersFromServer(req);
  try {
    const mainData = await mockApi.getMainData(params.locale);
    const pageData = await mockApi.getPageData(params.locale, 'media');
    return {
      props: {
        initialState: {
          main: mainData,
        },
        page: pageData,
        headersParse,
        ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
      },
    };
  } catch {
    return {
      notFound: true
    };
  }
};

const Page = ({ page }) => {
  const { t } = useTranslation();

  const { viewport, lang } = useTheme();
  const metaData = {
    title: t('meta_titles.media'),
    description: t('meta_descriptions.media'),
    keywords: t('main_keywords'),
  };
  useMetaTags({ lang, ...metaData });

  if (!page) return null;

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <div className="container">
        <PageTitle
          breadcrumbs={[{ name: t('forma_in_media') }]}
          title={t('forma_in_media')}
        />

        <MediaGrid items={page} />
        <div style={{ margin: '40px' }} />
      </div>
    </div>
  );
};

export default Page;
